import React from "react";
import IntroductionPage from "../../components/applicant/onboarding/introduction-app/introduction-page";

const BossApplicantOnboarding = () => {
  return <IntroductionPage />;
};

export default BossApplicantOnboarding;
